var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "figure",
    {
      class: [_vm.sizeClass, { cropped: _vm.cropped }],
      style:
        "" + (_vm.cropped ? "background-image: url(" + _vm.avatar + ")" : null),
    },
    [_c("img", { attrs: { src: _vm.avatar, alt: _vm.alt } })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }